import { AdminRoutes } from 'app/modules/admin/AdminPage';

import { MenuItem } from './MenuItem';

export function AdminMenuItems () {
  return (
    <>
      <MenuItem title="Companies" to={AdminRoutes.Organizations} />
      <MenuItem title="Users" to={AdminRoutes.Users} />
      <MenuItem title="Manage Sponsors" to={AdminRoutes.Sponsors} />
      <MenuItem title="Comms" to={AdminRoutes.EmailTemplates} />
      <MenuItem title="User Manuals" to={AdminRoutes.UserManuals} />
    </>);
}
